import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

const InvalidPermissions = ({}) => {
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div className="block-content block-content-full">
					<div style={{ position: "relative" }}>
						<ExclamationTriangleIcon
							style={{ position: "absolute", height: 50, color: "white", marginLeft: 5, marginTop: 5 }}
						/>
						<span className="item item-circle bg-primary" />
					</div>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center">Whoops!..</h1>
					<p className="text-center">It seems that you have insufficient permissions to view this page.</p>
					<p className="text-center">Kindly contact your admin for more information!</p>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvalidPermissions)